export const lastUpdateThresholdMS = 600000